import AppLabel from "components/Tags/AppLabel";
import AppTag from "components/Tags/AppTag";
import { Fragment, useMemo } from "react";
import { underscoreGet } from "utils/GeneralUtils";

//TODO: Add support for things other than Tags. Currently only uses AppTag component to display items.
const SelectablePopover = ({
  options,
  groupBy,
  sortBy,
  full = false,
  groupByLabels,
}) => {
  const optionsData = useMemo(() => {
    if (!options) return null;
    let sortedOptions = options;

    if (sortBy && !groupBy && !Array.isArray(options)) {
      options.sort((a, b) => a?.[sortBy].localeCompare(b?.[sortBy]));
    } else {
      options.sort((a, b) => a?.Name.localeCompare(b.Name));
    }

    if (!groupBy) {
      return options;
    }

    const data = {};

    for (const option of sortedOptions) {
      let group = underscoreGet(option, groupBy, "");

      if (groupByLabels && group) {
        const foundLabel = groupByLabels[group];

        if (foundLabel) group = foundLabel;
      }

      if (data[group]) {
        data[group].push(option);
      } else {
        data[group] = [option];
      }
    }

    // Sort each group's array
    if (sortBy) {
      Object.keys(data)?.forEach((type) => {
        data[type] = data[type].sort((a, b) =>
          a?.[sortBy].localeCompare(b?.[sortBy])
        );
      });
    }

    return data;
  }, [options, groupBy, sortBy, groupByLabels]);

  if (!options || options?.length < 1) return null;

  return (
    <div
      className="p-2 tag-popover-container w-100"
      style={{ maxWidth: full ? "100%" : 400 }}
    >
      {!Array.isArray(optionsData)
        ? Object.keys(optionsData)?.map((type) => {
            const currentTags = optionsData[type];

            return (
              <Fragment key={type}>
                <div className="tag-popover-person-label tag-popover-scope-label w-100">
                  <h5 className="pl-1 mb-2">{type}</h5>
                  <hr className="tag-popover-hr-divider mb-2 mt-0 mx--2" />
                </div>

                <div className="d-flex flex-wrap justify-content-start mb-4">
                  {currentTags?.map((tag) => (
                    <div className="tag-popover-tag" key={tag?.id}>
                      <AppTag tag={tag} />
                    </div>
                  ))}
                </div>
              </Fragment>
            );
          })
        : optionsData.map((tag) => (
            <div className="tag-popover-tag" key={tag?.id}>
              <AppLabel label={tag} />
            </div>
          ))}
    </div>
  );
};

export default SelectablePopover;
